module.exports = __webpack_public_path__ + "img/specif_eng.2750065b.jpg";